import { render, staticRenderFns } from "./AdminManageQuestionsCategories.vue?vue&type=template&id=1ceeb962&scoped=true"
import script from "./AdminManageQuestionsCategories.vue?vue&type=script&lang=js"
export * from "./AdminManageQuestionsCategories.vue?vue&type=script&lang=js"
import style0 from "./AdminManageQuestionsCategories.vue?vue&type=style&index=0&id=1ceeb962&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceeb962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ceeb962')) {
      api.createRecord('1ceeb962', component.options)
    } else {
      api.reload('1ceeb962', component.options)
    }
    module.hot.accept("./AdminManageQuestionsCategories.vue?vue&type=template&id=1ceeb962&scoped=true", function () {
      api.rerender('1ceeb962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminManageQuestionsCategories.vue"
export default component.exports